//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { PortalType } from './Enums';

export abstract class SendLoginEmailInputItem extends ItemBase {
    PortalType: PortalType = PortalType.StudentPortal;

    static readonly ClassName: string = "SendLoginEmailInputItem";
}
